/* eslint-disable no-undef */
import useScript from 'react-script-hook';
import { getScript } from '../../helpers';
import { useState } from 'react';

// this is done for testing purposes to reset the singleton instance in the test.
export let alreadyInitiated = { value: false };

export const useTagManager = ({ env }) => {
  const [loadScript, setLoadScript] = useState(false);
  // We need this outside of the useScript hook so the internal useMemo
  // is always called, to avoid changing the order of called hooks
  const scriptSrc = getScript(env);
  useScript({
    src: loadScript ? scriptSrc : null,
    checkForExisting: true,
  });

  const identifyBrazeUser = (bid) => {
    if (!alreadyInitiated.value) {
      console.warn('Tag Manager needs to be initiated');
      return;
    }
    globalThis.onlyfyServerParams.bid = bid;
    globalThis.braze?.changeUser(globalThis.onlyfyServerParams.bid);
  };

  const initializeTagManagerOnce = ({ bid, options }) => {
    if (typeof window === 'undefined') {
      return;
    }

    if (alreadyInitiated.value) {
      console.warn('Tag Manager already initiated');
      return;
    }

    alreadyInitiated.value = true;

    // The internal script needs onlyfyServerParams to be defined
    const onlyfyServerParams = globalThis.onlyfyServerParams ?? {};
    onlyfyServerParams.bid = bid;
    globalThis.onlyfyServerParams = onlyfyServerParams;

    const _mtm = globalThis._mtm ?? [];
    _mtm.push({
      'mtm.startTime': new Date().getTime(),
      event: 'mtm.Start',
    });

    if (options) {
      _mtm.push(options);
    }

    globalThis._mtm = _mtm;
    setLoadScript(true);
  };

  return {
    initializeTagManagerOnce,
    identifyBrazeUser,
    isTagManagerInitiated: alreadyInitiated.value,
  };
};
